const COOKIE_NAME = 'user-selected-country'
const COOKIE_EXPIRES_DAYS = 30

class CountrySwitcher extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()

    this.showOnLoad = this.getBooleanAttr('data-show-on-load')
    this.currentCountry = this.getAttribute('data-current-country') || ''
    this.currentMarket = this.getAttribute('data-current-market') || ''

    this.init()
  }

  setupListeners () {
    super.setupListeners()

    this.listeners.add(
      this.els.select.element,
      'change',
      this.handleChange.bind(this),
    )

    this.listeners.add(
      this.els.submit.element,
      'click',
      this.handleSubmit.bind(this),
    )

    this.listeners.add(this.els.dialog.element, 'click', (event) => {
      if (event.target === this.els.dialog.element) {
        this.closeSwitcher()
      }
    })

    document.addEventListener('click', (event) => {
      if (
        event.target.closest('[data-country-switcher-external-el="trigger"]')
      ) {
        this.openSwitcher()
      }
    })
  }

  async init () {
    const cookie = this.getCookie()
    const customerCountry = await this.detectCustomerCountry()
    const preselect = cookie?.country || customerCountry || this.currentCountry

    this.setSelectValue(preselect)

    if (this.showOnLoad && !cookie) {
      const customerInMarket = await this.isCustomerInCurrentMarket()

      if (!customerInMarket) {
        this.openSwitcher()
        return
      }
    }

    this.closeSwitcher()
  }

  async detectCustomerCountry () {
    if (this.detectedCountry !== undefined) {
      return this.detectedCountry
    }

    try {
      const res = await fetch('/browsing_context_suggestions.json', {
        credentials: 'same-origin',
      })

      if (!res.ok) throw new Error('Failed fetching suggestions')

      const data = await res.json()

      this.detectedCountry =
        data?.detected_values?.country?.handle || this.currentCountry || null
    } catch {
      this.detectedCountry = this.currentCountry || null
    }

    return this.detectedCountry
  }

  async isCustomerInCurrentMarket () {
    const customerCountry = await this.detectCustomerCountry()

    if (!customerCountry) return false

    return customerCountry.toUpperCase() === this.currentCountry.toUpperCase()
  }

  setCookie (value, days = COOKIE_EXPIRES_DAYS) {
    const expires = new Date()
    expires.setTime(expires.getTime() + days * 86400000)

    document.cookie = `${COOKIE_NAME}=${encodeURIComponent(
      JSON.stringify(value),
    )}; path=/; expires=${expires.toUTCString()}`
  }

  getCookie () {
    const match = document.cookie.match(
      new RegExp(`(^| )${COOKIE_NAME}=([^;]+)`),
    )
    if (!match) return null

    try {
      return JSON.parse(decodeURIComponent(match[2]))
    } catch {
      return null
    }
  }

  handleChange () {
    const selectedOption =
      this.els.select.element.options[this.els.select.element.selectedIndex]

    if (!selectedOption) return

    const country = selectedOption.value
    const name = selectedOption.textContent || ''

    this.setCookie({ country, name })
  }

  handleSubmit () {
    if (!this.getCookie()) {
      const select = this.els.select.element
      const selectedOption = select.options[select.selectedIndex]

      if (selectedOption) {
        this.setCookie({
          country: selectedOption.value,
          name: selectedOption.textContent || '',
        })
      }
    }

    this.closeSwitcher()
  }

  setSelectValue (countryCode) {
    const select = this.els.select.element
    const option = [...select.options].find((opt) => opt.value === countryCode)

    if (option) {
      select.value = countryCode
    }
  }

  getBooleanAttr (attrName) {
    const val = this.getAttribute(attrName)
    if (val === null) return false
    return val === 'true' || val === '1'
  }

  openSwitcher () {
    this.els.dialog.element.showModal()
  }

  closeSwitcher () {
    this.els.dialog.element.close()
  }
}

if (!customElements.get('country-switcher')) {
  customElements.define('country-switcher', CountrySwitcher)
}
